"use strict";
exports.__esModule = true;
exports.DeliveryProviderFleetLegacyType = exports.DeliveryProviderContractType = exports.DeliveryProviderStatus = exports.DeliveryProviderEcoFriendlyType = exports.DeliveryProviderDeliverFromCapability = exports.DeliveryProviderSecurityCapability = exports.DeliveryProviderServiceCapability = exports.DeliveryProviderServiceLevelCapability = exports.DeliveryProviderCommitmentTimeCapability = exports.DeliveryProviderSkillCapability = exports.DeliveryProviderVehicleCapability = exports.DeliveryProviderIndustryCapability = void 0;
var DeliveryProviderIndustryCapability;
(function (DeliveryProviderIndustryCapability) {
    DeliveryProviderIndustryCapability["big_and_bulky"] = "big_and_bulky";
    DeliveryProviderIndustryCapability["restaurant"] = "restaurant";
    DeliveryProviderIndustryCapability["groceries"] = "groceries";
    DeliveryProviderIndustryCapability["healthcare"] = "healthcare";
    DeliveryProviderIndustryCapability["automotive"] = "automotive";
    DeliveryProviderIndustryCapability["meal_kit"] = "meal_kit";
})(DeliveryProviderIndustryCapability = exports.DeliveryProviderIndustryCapability || (exports.DeliveryProviderIndustryCapability = {}));
var DeliveryProviderVehicleCapability;
(function (DeliveryProviderVehicleCapability) {
    DeliveryProviderVehicleCapability["on_foot"] = "on_foot";
    DeliveryProviderVehicleCapability["bikes"] = "bikes";
    DeliveryProviderVehicleCapability["cargo_bikes"] = "bikes";
    DeliveryProviderVehicleCapability["bicycles"] = "bicycles";
    DeliveryProviderVehicleCapability["cars"] = "cars";
    DeliveryProviderVehicleCapability["vans"] = "vans";
    DeliveryProviderVehicleCapability["trucks"] = "trucks";
    DeliveryProviderVehicleCapability["robots"] = "robots";
    DeliveryProviderVehicleCapability["drones"] = "drones";
})(DeliveryProviderVehicleCapability = exports.DeliveryProviderVehicleCapability || (exports.DeliveryProviderVehicleCapability = {}));
var DeliveryProviderSkillCapability;
(function (DeliveryProviderSkillCapability) {
    DeliveryProviderSkillCapability["proof_of_delivery"] = "proof_of_delivery";
    DeliveryProviderSkillCapability["quotes"] = "quotes";
    DeliveryProviderSkillCapability["multi_parcel"] = "multi_parcel";
    DeliveryProviderSkillCapability["update_order"] = "update_order";
    DeliveryProviderSkillCapability["driver_live_tracking"] = "driver_live_tracking";
    DeliveryProviderSkillCapability["cancel_order"] = "cancel_order";
})(DeliveryProviderSkillCapability = exports.DeliveryProviderSkillCapability || (exports.DeliveryProviderSkillCapability = {}));
var DeliveryProviderCommitmentTimeCapability;
(function (DeliveryProviderCommitmentTimeCapability) {
    DeliveryProviderCommitmentTimeCapability["min30"] = "min30";
    DeliveryProviderCommitmentTimeCapability["min60"] = "min60";
    DeliveryProviderCommitmentTimeCapability["min120"] = "min120";
})(DeliveryProviderCommitmentTimeCapability = exports.DeliveryProviderCommitmentTimeCapability || (exports.DeliveryProviderCommitmentTimeCapability = {}));
var DeliveryProviderServiceLevelCapability;
(function (DeliveryProviderServiceLevelCapability) {
    DeliveryProviderServiceLevelCapability["on_demand"] = "on_demand";
    DeliveryProviderServiceLevelCapability["same_day"] = "same_day";
    DeliveryProviderServiceLevelCapability["scheduled"] = "scheduled";
})(DeliveryProviderServiceLevelCapability = exports.DeliveryProviderServiceLevelCapability || (exports.DeliveryProviderServiceLevelCapability = {}));
var DeliveryProviderServiceCapability;
(function (DeliveryProviderServiceCapability) {
    DeliveryProviderServiceCapability["installation"] = "installation";
    DeliveryProviderServiceCapability["assambly"] = "assambly";
    DeliveryProviderServiceCapability["room_of_choice"] = "room_of_choice";
    DeliveryProviderServiceCapability["over_the_threshold"] = "over_the_threshold";
    DeliveryProviderServiceCapability["contactless"] = "contactless";
    DeliveryProviderServiceCapability["dangerous_goods"] = "dangerous_goods";
    DeliveryProviderServiceCapability["fragile"] = "fragile";
    DeliveryProviderServiceCapability["alcohol"] = "alcohol";
    DeliveryProviderServiceCapability["medical"] = "medical";
})(DeliveryProviderServiceCapability = exports.DeliveryProviderServiceCapability || (exports.DeliveryProviderServiceCapability = {}));
var DeliveryProviderSecurityCapability;
(function (DeliveryProviderSecurityCapability) {
    DeliveryProviderSecurityCapability["iso"] = "iso";
    DeliveryProviderSecurityCapability["soc2"] = "soc2";
})(DeliveryProviderSecurityCapability = exports.DeliveryProviderSecurityCapability || (exports.DeliveryProviderSecurityCapability = {}));
var DeliveryProviderDeliverFromCapability;
(function (DeliveryProviderDeliverFromCapability) {
    DeliveryProviderDeliverFromCapability["store"] = "store";
    DeliveryProviderDeliverFromCapability["warehouse"] = "warehouse";
})(DeliveryProviderDeliverFromCapability = exports.DeliveryProviderDeliverFromCapability || (exports.DeliveryProviderDeliverFromCapability = {}));
var DeliveryProviderEcoFriendlyType;
(function (DeliveryProviderEcoFriendlyType) {
    DeliveryProviderEcoFriendlyType[DeliveryProviderEcoFriendlyType["Yes"] = 0] = "Yes";
    DeliveryProviderEcoFriendlyType[DeliveryProviderEcoFriendlyType["No"] = 1] = "No";
    DeliveryProviderEcoFriendlyType[DeliveryProviderEcoFriendlyType["Partial"] = 2] = "Partial";
})(DeliveryProviderEcoFriendlyType = exports.DeliveryProviderEcoFriendlyType || (exports.DeliveryProviderEcoFriendlyType = {}));
var DeliveryProviderStatus;
(function (DeliveryProviderStatus) {
    DeliveryProviderStatus[DeliveryProviderStatus["Pending"] = 0] = "Pending";
    DeliveryProviderStatus[DeliveryProviderStatus["InProgress"] = 1] = "InProgress";
    DeliveryProviderStatus[DeliveryProviderStatus["Active"] = 2] = "Active";
    DeliveryProviderStatus[DeliveryProviderStatus["Inactive"] = 3] = "Inactive";
})(DeliveryProviderStatus = exports.DeliveryProviderStatus || (exports.DeliveryProviderStatus = {}));
var DeliveryProviderContractType;
(function (DeliveryProviderContractType) {
    DeliveryProviderContractType[DeliveryProviderContractType["HubAggregator"] = 0] = "HubAggregator";
    DeliveryProviderContractType[DeliveryProviderContractType["HubDirect"] = 1] = "HubDirect";
    DeliveryProviderContractType[DeliveryProviderContractType["NonHub"] = 2] = "NonHub";
})(DeliveryProviderContractType = exports.DeliveryProviderContractType || (exports.DeliveryProviderContractType = {}));
var DeliveryProviderFleetLegacyType;
(function (DeliveryProviderFleetLegacyType) {
    DeliveryProviderFleetLegacyType[DeliveryProviderFleetLegacyType["BringgIntegration"] = 0] = "BringgIntegration";
    DeliveryProviderFleetLegacyType[DeliveryProviderFleetLegacyType["SelfIntegration"] = 1] = "SelfIntegration";
    DeliveryProviderFleetLegacyType[DeliveryProviderFleetLegacyType["Bringg2Bringg"] = 2] = "Bringg2Bringg";
    DeliveryProviderFleetLegacyType[DeliveryProviderFleetLegacyType["Aggregator"] = 3] = "Aggregator";
})(DeliveryProviderFleetLegacyType = exports.DeliveryProviderFleetLegacyType || (exports.DeliveryProviderFleetLegacyType = {}));
//# sourceMappingURL=delivery_provider.js.map